import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-zinc-900 text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-500 flex items-center justify-center flex-shrink-0">
                <span className="text-white text-xs font-black tracking-tight">CV</span>
              </div>
              <span className="font-bold text-xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
                <span className="text-white">JobMatch </span>
                <span className="bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">CV</span>
              </span>
            </Link>
            <p className="text-zinc-400 mb-4 max-w-sm">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-semibold mb-4 text-zinc-300">{t('footer.product')}</h3>
            <ul className="space-y-3 text-zinc-400">
              <li>
                <Link to="/tarifs" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">
                  {t('footer.pricing', { defaultValue: 'Tarifs' })}
                </Link>
              </li>
              <li>
                <Link to="/analyser" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">
                  {t('footer.register')}
                </Link>
              </li>
              <li>
                <a href="mailto:contact@jobmatch-cv.com" className="hover:text-white transition-colors">
                  {t('footer.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-zinc-300">{t('footer.legal')}</h3>
            <ul className="space-y-3 text-zinc-400">
              <li>
                <Link to="/confidentialite" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/conditions" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-8 text-center text-zinc-500 text-sm">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
